export enum ContractTypesEnum {
  FUTURES = 'FUTURES',
  EXTRA_FUTURES = 'EXTRA_FUTURES',
  STORAGE = 'STORAGE',
  SPOT = 'SPOT',
  STATE_RESERVE = 'STATE_RESERVE',
  FORWARD = 'FORWARD',
  SEED = 'SEED',
}
